import {
  IDeleteTimeClock,
  IEditTimeClock,
  IParamsGetTimeClockSelection,
  IParamsGetTimeClocks,
  IResponseGetTimeClocks,
  IResponseGetTimeClocksSelection,
  ITimeClock,
  ITimeClockEvent,
} from '~/utils/interface/timeClock';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

const timeClockApi = {
  getTimeClocks(params: IParamsGetTimeClocks) {
    const url = `api/admin/time-clocks`;
    return axiosClient.get<IApiBaseResponse<IResponseGetTimeClocks>>(url, { params });
  },
  export(params: IParamsGetTimeClocks) {
    const url = `api/admin/time-clocks/export`;
    return axiosClient.get<IApiBaseResponse<any>>(url, { params });
  },
  getSelection(params: IParamsGetTimeClockSelection) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTimeClocksSelection>>(`api/admin/time-clocks/selection`, {
      params,
    });
  },
  getTimeClock(id: string) {
    return axiosClient.get<IApiBaseResponse<ITimeClockEvent>>(`api/admin/time-clocks/${id}`);
  },
  checkinTimeClock(data: IEditTimeClock) {
    return axiosClient.post<IApiBaseResponse<ITimeClock>>(`api/admin/time-clocks/check-in`, data);
  },
  updateTimeClock(id: string, data: IEditTimeClock) {
    return axiosClient.put<IApiBaseResponse<ITimeClock>>(`api/admin/time-clocks/${id}`, data);
  },
  deleteTimeClock(data: IDeleteTimeClock) {
    return axiosClient.delete<IApiBaseResponse<null>>('api/admin/time-clocks', { data });
  },
};

export default timeClockApi;
